export enum UndoRedoAction {
    ADD = 'add',
    REMOVE = 'remove'
}
